/**
 * 2026-10-27 ruling: a list's name and a field's label are different things. The reference list is named for its
 * members and stays plural ("Finding severities"); the label over a control that picks ONE value is singular
 * ("Severity"). The list names in reference data do not change, so the singular lives here, by domain. A domain
 * with no entry is a defect, not a fallback: it is said by name, and fieldName.test.tsx checks every picker.
 */
const FIELD_NAMES: Record<string, string> = {
  confidence: "Confidence",
  currency: "Currency",
  dd_answer_source: "Answer source",
  dd_closure_outcome: "Outcome",
  dd_confidentiality: "Confidentiality",
  dd_deal_stage: "Deal stage",
  dd_deal_type: "Deal type",
  dd_ebitda_band: "EBITDA band",
  dd_engagement_stage: "Diligence stage",
  dd_impact: "Impact",
  dd_inventory_type: "Inventory type",
  dd_likelihood: "Likelihood",
  dd_match_basis: "Match basis",
  dd_ownership: "Ownership",
  dd_participant_side: "Side",
  dd_question_lens: "Lens",
  dd_question_type: "Question type",
  dd_rating: "Rating",
  dd_request_status: "Request status",
  dd_revenue_band: "Revenue band",
  dd_risk_category: "Category",
  dd_session_mode: "Session mode",
  dd_severity: "Severity",
  dd_synergy_basis: "Basis",
  dd_verdict: "Verdict"
};

/** The singular label over a control that picks one value of this list. */
export const fieldName = (domain: string): string => {
  const name = FIELD_NAMES[domain];
  if (!name) throw new Error(`No field name for the list "${domain}": add it to fieldName.ts.`);
  return name;
};
export const FIELD_NAME_DOMAINS = Object.keys(FIELD_NAMES);
